import i18next from 'i18next';
import { getEnv } from '../utils/env';

interface StoreState {
  translations?: Record<string, any>;
  [key: string]: any;
}

interface Store {
  state?: StoreState;
  setState?: (updater: (prevState: StoreState) => StoreState) => void;
}

export const fetchTranslations = async (locale: string) => {
  console.log(`[i18n] fetching ${locale} translations`);
  const formattedLocale = `${locale}unflatten.json`;
  const url = `${getEnv('TRANSLATION_SERVICE_URL')}/MSCC/${formattedLocale}`;
  try {
    const response = await fetch(url);
    const data = await response.json();
    console.log(`[i18n] Translations fetched successfully for ${locale}`);
    return data;
  } catch (e) {
    console.error(`[i18n] Error fetching translations for ${locale}:`, e);
    return {};
  }
};

export const initializeI18n = async (locale: string, store?: Store | null) => {
  let translations = store?.state?.translations?.[locale];
  if (!translations) {
    console.log(`[i18n] ${locale} translations not in store`);
    translations = await fetchTranslations(locale);
    if (store && store.setState) {
      store.setState((prevState: StoreState) => ({
        ...prevState,
        translations: {
          ...prevState?.translations,
          [locale]: translations
        }
      }));
    }
  }
  const normalizedLocale = locale === 'zh-HANS' ? 'zh-Hans' : locale;
  const resources = {
    [normalizedLocale]: { translation: translations }
  };
  await i18next.init({
    lng: normalizedLocale,
    debug: true,
    resources
  });
};
